<template>
  <div class="form-type-selector">
    <div
      class="lavendla-slide-in__desc"
      @click="gtmPhoneCallTrigger($event, `Contact Form Modal - Form selector`)"
      v-html="descText"
    />

    <div class="form-type-selector__button-group">
      <button
        v-for="item in formTypes"
        :key="item.type"
        class="btn cta"
        :label="item.label"
        @click="updateFormType(item.type)"
        v-text="item.label"
      />
    </div>
  </div>
</template>

<script>
import { usePhoneNumber } from 'Main/composables/usePhoneNumber';

export default {
  setup() {
    const {
      phoneNumber,
      phoneNumberTel,
      hidePhoneNumber,
      isTherapyPage,
      countryPhoneCode,
      maybeUpdatePhoneNumber,
      updatePhoneNumber,
      ctmRunNow,
      ctmInit,
      gtmPhoneCallTrigger,
    } = usePhoneNumber();
    return {
      phoneNumber,
      phoneNumberTel,
      hidePhoneNumber,
      isTherapyPage,
      countryPhoneCode,
      maybeUpdatePhoneNumber,
      updatePhoneNumber,
      ctmRunNow,
      ctmInit,
      gtmPhoneCallTrigger,
    };
  },

  props: {
    locale: {
      type: String,
      default: 'sv_SE',
    },
    texts: {
      type: Object,
      default() {
        return {};
      },
    },
    descText: {
      type: String,
      default: '',
    },
    textContent: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    const types = theme_vars.siteRequestTypesList || [];
    return {
      formTypes: Object.keys(types).map((key) => {
        return {
          type: this.getKey(key),
          label: types[key],
        };
      }),
    };
  },

  methods: {
    getKey(key) {
      switch (key) {
        case 'funeral':
          return 'city';
        case 'law':
          return 'jurist';
        default:
          return key;
      }
    },
    updateFormType(val) {
      this.$emit('update-form-type', val);
    },
  },
};
</script>
